var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        {
          ref: "target",
          staticClass:
            "dropzone d-flex justify-content-center align-items-center"
        },
        [_vm._m(0)]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dz-message" }, [
      _vm._v("\n                Drag and drop files here\n                "),
      _c("div", { staticClass: "my-2" }, [
        _vm._v("\n                    or\n                ")
      ]),
      _vm._v(" "),
      _c("button", { staticClass: "btn btn-default" }, [
        _vm._v("\n                    click here\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2 mb-0" }, [
        _vm._v("\n                    Maximum file size is "),
        _c("strong", [_vm._v("20 MB")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }